define('SageDotCom/DataLayer/Events/skinnyBannerClick',['jquery', 'SageDotCom/DataLayer/Events/eventBase'], function ($, EventBase) {

    function SkinnyBannerClickEvent() {
        EventBase.call(this); // inherit eventBase
        this.name = 'banner_click'; // overwrite name
    }

    SkinnyBannerClickEvent.prototype = Object.create(EventBase.prototype);

    SkinnyBannerClickEvent.prototype.GenerateEventMetadata = function GenerateEventMetadata(scope) {
        var eventData = {
            "event": this.getName() //event name
        }

        if (scope) {
            var link = $(scope).find("a");
            eventData = $.extend(eventData, {
                "message": link.length > 0 ? link[0].innerText : "",
                "element_text": link.length > 0 ? link[0].innerText : "",
                "destination_url": link.length > 0 ? link[0].href : ""
            });
        }
        return eventData;
    }

    return new SkinnyBannerClickEvent();
});
